import React, { useState, useEffect } from "react";
import stylesInputLabel from "../../styles/Atoms/InputLabel/label";
import { useTranslation } from "react-i18next";
import { Visibility as VisibilityIcon, VisibilityOff as VisibilityOffIcon } from "@mui/icons-material";

const InputLabel = ({
  label,
  inputType,
  options = [],
  selectwidth,
  inputwidth,
  color,
  backgroundColor,
  value = [],
  setValue = () => {},
  hdlOnFocus = () => {},
  hdlOnChange = () => {},
  onMouseDown = () => {}, 
  onclick=()=>{},
  validate = () => "",
  errorText = "",
  onTextChange = () => {},
  shadow = false,
  onBubblesChange = () => {},
  MultiSelect = false,
  disabled = false,
  // 🆕 Props opcionales
  fontSize = "14px",
  inputBgColor,
  selectBgColor,
  autoComplete,
  Visibility: visibilityProp,
  showEye
}) => {
  const { t } = useTranslation();

  const colorDefecto = color ?? "#708198";
  const backgroundDefecto = backgroundColor ?? "#edeff2";

  const finalInputBg = inputBgColor ?? backgroundDefecto;
  const finalSelectBg = selectBgColor ?? backgroundDefecto;

  const [validationError, setValidationError] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [showPassword, setShowPassword] = useState(visibilityProp ?? false);

  const needsSoftBorder = (bg) =>
    bg === "#fff" || bg === "#ffffff" || bg === "white";

  const softShadow = "0px 4px 12px rgba(0,0,0,0.2)";

  useEffect(() => {
    if (Array.isArray(value) && value.length > 0) {
      setSelectedOptions(value);
    }
  }, [value]);

  useEffect(() => {
    const error = validate(value);
    setValidationError(error || "");
  }, [value, validate]);

  useEffect(() => {
    if (visibilityProp !== undefined) {
      setShowPassword(visibilityProp);
    }
  }, [visibilityProp]);

  const getChangeSelect = (e) => {
    const selectedValue = e.target.value;
    setValue(selectedValue);
    hdlOnChange(selectedValue);

    const selectedOption = options.find((opt) => opt.value === selectedValue);

    if (MultiSelect) {
      if (
        selectedOption &&
        !selectedOptions.some((opt) => opt.value === selectedOption.value)
      ) {
        const updated = [...selectedOptions, selectedOption];
        setSelectedOptions(updated);
        onBubblesChange(updated);
      }
    } else {
      setSelectedOptions(selectedOption ? [selectedOption] : []);
      onBubblesChange(selectedOption ? [selectedOption] : []);
    }
  };

  const getNweValue = (e) => {
    const inputValue = e.target.value;
    setValue(inputValue);
    hdlOnChange(inputValue);
    onTextChange(inputValue);
    setValidationError(validate(inputValue) || "");
  };

  const removeSelectedOption = (optionValue) => {
    const updatedSelectedOptions = selectedOptions.filter(
      (opt) => opt.value !== optionValue,
    );
    setSelectedOptions(updatedSelectedOptions);
    onBubblesChange(updatedSelectedOptions);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const isPassword = inputType === "password";
  const currentInputType = isPassword && showPassword ? "text" : inputType;
  const finalAutoComplete = autoComplete || (isPassword ? "new-password" : "off");

  return (
    <div>
      <label
        style={{
          ...stylesInputLabel.label,
          color: colorDefecto,
          fontWeight: 600,
          fontFamily: "Raleway, sans-serif",
        }}
      >
        {label}
      </label>

      {inputType === "select" ? (
        <>
          <select
            value={MultiSelect ? "" : value}
            disabled={disabled}
            style={{
              ...stylesInputLabel.select,
              backgroundColor: finalSelectBg,
              fontFamily: "Raleway, sans-serif",
              fontSize,
              width: selectwidth,
              boxShadow:
                shadow || needsSoftBorder(finalSelectBg) ? softShadow : "none",
              opacity: disabled ? 0.6 : 1,
              cursor: disabled ? "not-allowed" : "pointer",
            }}
            onChange={getChangeSelect}
            onFocus={hdlOnFocus}
            onClick={onclick}
            onMouseDown={onMouseDown}
          >
            <option value="" disabled>
              {t("Welcome.text249")}
            </option>

            {options.map((option, index) => (
              <option key={index} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>

          {MultiSelect && selectedOptions.length > 0 && (
            <div style={{ marginTop: "8px" }}>
              {selectedOptions.map((opt) => (
                <div key={opt.value} style={bubbleStyle}>
                  {opt.label}
                  <button
                    onClick={() => removeSelectedOption(opt.value)}
                    style={closeButtonStyle}
                  >
                    ✖
                  </button>
                </div>
              ))}
            </div>
          )}
        </>
      ) : (
        <div style={{ position: "relative", width: inputwidth || "100%" }}>
          <input
            type={currentInputType}
            autoComplete={finalAutoComplete}
            value={value}
            disabled={disabled}
            onChange={disabled ? undefined : getNweValue}
            onFocus={disabled ? undefined : hdlOnFocus}
            style={{
              ...stylesInputLabel.input,
              width: "100%",
              backgroundColor: finalInputBg,
              fontFamily: "Raleway, sans-serif",
              fontSize,
              boxShadow:
                shadow || needsSoftBorder(finalInputBg) ? softShadow : "none",
              opacity: disabled ? 0.6 : 1,
              cursor: disabled ? "not-allowed" : "text",
              paddingRight: isPassword ? "35px" : "8px",
              boxSizing: "border-box",
            }}
          />
          {isPassword && showEye && (
            <div
              onClick={togglePasswordVisibility}
              style={{
                position: "absolute",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                color: "gray",
              }}
            >
              {showPassword ? (
                <VisibilityOffIcon sx={{ fontSize: 20 }} />
              ) : (
                <VisibilityIcon sx={{ fontSize: 20 }} />
              )}
            </div>
          )}

          {(validationError || errorText) && (
            <div style={stylesInputLabel.error}>
              {validationError || errorText}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const bubbleStyle = {
  display: "inline-flex",
  alignItems: "center",
  backgroundColor: "#d1ecf1",
  color: "#0c5460",
  borderRadius: "16px",
  padding: "5px 10px",
  margin: "4px",
  fontSize: "14px",
};

const closeButtonStyle = {
  marginLeft: "8px",
  background: "none",
  border: "none",
  cursor: "pointer",
  fontSize: "14px",
  color: "#721c24",
};

export default InputLabel;

